<div class="results-content" data-test="result-content">
  <div class="row">
    <div
      *ngIf="results.resultsDropdown"
      class="col-md-12 flo-sort-container d-flex justify-content-end align-items-center"
    >
      <span class="col-lg-2 px-0 d-none d-lg-block">Show Results</span>
      <div class="dropdown-form" *ngIf="!results.showDropdown">
        : {{ results?.filterValue[0] }}
      </div>
      <flo-select-input
        class="col-lg-3 px-0"
        *ngIf="results.showDropdown"
        [initial]="results?.sort"
        [formControl]="filterForm.get('sort')"
        [options]="results?.selectOptions"
        ngDefaultControl
      >
      </flo-select-input>
    </div>
  </div>

  <ng-container
    *ngFor="let content of results.content; trackBy: trackByResultContent"
  >
    <div class="w-100 content py-4 pt-md-2 pb-md-0 result-top-content">
      <div class="teaser" *ngIf="!content.showContent">
        <p
          class="description"
          [innerHtml]="content?.preview_text | floSanitizeHtml"
        ></p>
        <span class="read-more primary-color-text">Read more</span>
      </div>

      <div *ngIf="content.showContent && content.content" class="full-content" floDynamicContent>
        <p
          class="description"
          [innerHtml]="content?.content | floSanitizeHtml"
        ></p>
      </div>
    </div>
  </ng-container>

  <ng-container
    *ngFor="let resultData of results.resultsData; trackBy: trackByResultData"
  >
    <div class="w-100 content py-4 pt-md-2 pb-md-0 result-lower-content">
      <div class="full-content" floDynamicContent>
        <p [innerHtml]="resultData?.content | floSanitizeHtml"></p>
      </div>
    </div>
  </ng-container>
</div>
